import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';

const Footer = ({authenticated, signOut}) => (
		<div className="footer footer--dark">
<div className="container">
    <div className="footer__inner">
        <a href="/" className="footer__textLogo">Colivingly</a>
        <div className="footer__data">
            <div className="footer__data__item">
                <div className="footer__row">
                    Made by <a href="https://twitter.com/graeme_fulton" target="_blank" className="footer__link">Graeme</a>
                </div>
                <div className="footer__row">
                    
                </div>
            </div>
            <div className="footer__data__item">
                <div className="footer__row">Made by <a href="https://twitter.com/graeme_fulton" target="_blank" className="footer__link">Graeme</a> with <a href="https://undraw.co" target="_blank" className="footer__link">unDraw</a>
                </div>
            </div>
            <div className="footer__data__item">
            <div className="footer__row">
                <a href="https://twitter.com/graeme_fulton" target="_blank" className="footer__link">Twitter</a>
            </div>
            <div className="footer__row">
                {/* <a href="https://www.facebook.com/littleenglishgibraltar/" target="_blank" className="footer__link">Facebook</a> */}
            </div>
        </div>
    </div>
</div>
</div>
	</div>
);


export default Footer;




// WEBPACK FOOTER //
// ./src/views/components/footer/footer.js